import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchChartAccounts = async ( periodName, chartName ) => await fetch(
  Config.endpoints.FETCH_ADMIN_CHART_ACCOUNTS
    .replace(/:chartName/, encodeURIComponent(chartName))
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Admin Chart Accounts failed', parseResponseErrorMessage: true }))
  .then(parseAsJson);

export const fetchChartEditValidation = async ( periodName, chartName ) => await fetch(
  Config.endpoints.FETCH_CHART_EDIT_VALIDATION
    .replace(/:chartName/, encodeURIComponent(chartName))
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Chart Edit Validation failed' }))
  .then(parseAsJson);

export const fetchCharts = async periodName => await fetch(
  Config.endpoints.FETCH_CHART_NAMES_ALL
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching All Chart Names failed' }))
  .then(parseAsJson);

export const fetchChartsByUser = async periodName => await fetch(
  Config.endpoints.FETCH_CHART_NAMES_BY_USER
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching User Chart Names failed' }))
  .then(parseAsJson);

export const fetchAccountCodes = async () => await fetch(Config.endpoints.ACCOUNTS)
  .then(handleErrors({ errorMessage: 'Fetching accounts failed' }))
  .then(parseAsJson);

export const fetchImportStatus = async () => await fetch(
  Config.endpoints.FETCH_IMPORT_STATUS_VALUES
)
  .then(handleErrors({ errorMessage: 'Fetching import status failed' }))
  .then(parseAsJson);

export const addChart = async ({ chartData, periodName }) => await fetch(
  Config.endpoints.ADD_ADMIN_CHART
    .replace(/:periodName/, periodName)
    .replace(/:chartName/, encodeURIComponent(chartData.chartName)), {
    method: 'POST',
    body: JSON.stringify(chartData),
  }
)
  .then(handleErrors({ errorMessage: 'Adding Chart failed' }));

export const updateChart = async ({ chartData, periodName, entityToEdit }) => await fetch(
  Config.endpoints.UPDATE_ADMIN_CHART
    .replace(/:periodName/, periodName)
    .replace(/:chartName/, encodeURIComponent(chartData.chartName))
    .replace(/:originalChartName/, encodeURIComponent(entityToEdit.originalChartName)), {
    method: 'PUT',
    body: JSON.stringify(chartData),
  }
)
  .then(handleErrors({ errorMessage: 'Updating Chart failed' }));

export const deleteChart = async ( periodName, chartName ) => await fetch(
  Config.endpoints.DELETE_ADMIN_CHART
    .replace(':periodName', periodName)
    .replace(':chartName', chartName), {
    method: 'DELETE',
  }
)
  .then(handleErrors({ errorMessage: 'Removing Chart failed' }));

export const addChartAccount = async ({ periodName, chartName, chartAccountData }) => await fetch(
  Config.endpoints.ADD_ADMIN_CHART_ACCOUNT
    .replace(/:periodName/, periodName)
    .replace(/:chartName/, encodeURIComponent(chartName)), {
    method: 'POST',
    body: JSON.stringify(chartAccountData),
  }
)
  .then(handleErrors({ errorMessage: 'Adding Chart Account failed' }));

export const updateChartAccount = async ({ periodName, chartName, chartAccountData }) => await fetch(
  Config.endpoints.UPDATE_ADMIN_CHART_ACCOUNT
    .replace(/:periodName/, periodName)
    .replace(/:chartName/, encodeURIComponent(chartName))
    .replace(/:localAccount/, encodeURIComponent(chartAccountData.localAccount)), {
    method: 'PUT',
    body: JSON.stringify(chartAccountData),
  }
)
  .then(handleErrors({ errorMessage: 'Updating Chart Account failed' }));

export const deleteChartAccount = async ( periodName, chartName, localAccount ) => await fetch(
  Config.endpoints.DELETE_ADMIN_CHART_ACCOUNT
    .replace(':periodName', periodName)
    .replace(':chartName', chartName)
    .replace(':localAccount', localAccount), {
    method: 'DELETE',
  }
)
  .then(handleErrors({ errorMessage: 'Removing Chart Account failed' }));

export const importChart = async ({ periodName, chartName, chartData }) => await fetch(
  Config.endpoints.IMPORT_ADMIN_CHART
    .replace(/:chartName/, encodeURIComponent(chartName))
    .replace(/:periodName/, periodName), {
    method: 'POST',
    body: JSON.stringify(chartData),
  }
)
  .then(handleErrors({ errorMessage: 'Importing Chart failed' }));
